import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { currentRegion } from "../config/regions";
import { FEATURE_PRIVACY_POLICY } from "../config/featureFlags";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * US-only client redirect to a canonical medconcil.com legal URL.
 */
const LegalMarketingRedirect = ({ url, testId = "legal-marketing-redirect" }) => {
  const { t } = useLanguage();

  useEffect(() => {
    if (FEATURE_PRIVACY_POLICY && currentRegion === "us" && url) {
      window.location.replace(url);
    }
  }, [url]);

  if (!FEATURE_PRIVACY_POLICY || currentRegion !== "us") {
    return <Navigate to="/login" replace />;
  }

  return (
    <div
      className="min-h-screen bg-background text-foreground flex items-center justify-center px-4"
      data-testid={testId}
    >
      <p className="text-sm text-muted-foreground">{t("legal.redirecting")}</p>
    </div>
  );
};

export default LegalMarketingRedirect;
